import { createUseStyles } from 'react-jss'
import { boldFont, textSize } from 'styles/helpers'

const verificationCodeStyles = createUseStyles(theme => ({
  verificationCode: {
    '& input': {
      ...textSize(24, 26),
      ...boldFont(),
    },
    '& input:focus': {
      borderColor: theme.main_color,
      caretColor: theme.main_color,
    },
    '& input:first-child': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    '& input:last-child': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  }
}))

export default verificationCodeStyles
